import React from 'react';

const SouthAfrica = (props: { width: number }) => {
  return (
    <svg viewBox="0 0 800 534" {...props}>
      <rect fill="#000C8A" height="100%" width="100%" x="0" y="0" />
      <rect fill="#E1392D" height="50%" width="100%" x="0" y="0" />
      <path
        d="M 0,0 l 160,0 l 266,178 l 374,0 l 0,178 l -374,0 l -266,178 l -160,0 z"
        fill="#FFFFFF"
      />
      <path
        d="M 0,0 l 97 ,0 l 318,213 l 385,0 l 0,108 l -385,0 l -318,213 l -97,0 z"
        fill="#007847"
      />
      <path d="M 0,65 l 304,202 l -304,202 z" fill="#FFB915" />
      <path d="M 0,107 l 240,160 l -240,160 z" fill="#000000" />
    </svg>
  );
};

export default SouthAfrica;
